export const SEARCH_RESULTS_COUNT_FORMAT_MAX = 100000;
